import { render, staticRenderFns } from "./item-detail.vue?vue&type=template&id=5d109d0c&"
import script from "./item-detail.vue?vue&type=script&lang=ts&"
export * from "./item-detail.vue?vue&type=script&lang=ts&"
import style0 from "./item-detail.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports